// extracted by mini-css-extract-plugin
module.exports = {"faqSection":"shipsPage_faqSection__qoNwk","faqList":"shipsPage_faqList__GeiSL"};